// CustomDatePicker.js
import React, { useState } from "react";
import Modal from "react-modal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./CustomDatePicker.scss";

const CustomDatePicker = ({ isOpen, closeModal, handleDateRangeSelect }) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleSelectDateRange = () => {
    handleDateRangeSelect({ startDate, endDate });
    closeModal();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      contentLabel="Custom Date Picker"
    >
      {/* <h2>Select Date Range</h2> */}
      <div className="date-picker-container">
        <div className="date-picker">
          <p>Start Date:</p>
          <DatePicker
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            dateFormat="dd/MM/yyyy"
            placeholderText="Select Start Date"
            selectsStart
            startDate={startDate}
            endDate={endDate}
          />
        </div>
        <div className="date-picker">
          <p>End Date:</p>
          <DatePicker
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            dateFormat="dd/MM/yyyy"
            placeholderText="Select End Date"
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
          />
        </div>
      </div>

      <button className="dateclosebutton" onClick={closeModal}>Cancel</button>
      <button className="dateapplybutton" onClick={handleSelectDateRange}>Apply</button>
    </Modal>
  );
};

export default CustomDatePicker;
